import { useState, useEffect } from 'react';

const SUPABASE_URL = import.meta.env.VITE_TASKBLOOM_SUPABASE_URL || 'https://mxtkabejdsoqkgtqjaaw.supabase.co';
const FUNCTION_NAME = 'mechanical-pending-issues';

export interface PendingIssue {
  id: string;
  item_name: string;
  notes: string | null;
  is_resolved: boolean;
  resolved_at: string | null;
  resolution_notes: string | null;
  created_at: string;
  work_unit_name: string;
  equipment_code: string;
  equipment_name: string;
  report_date: string;
  inspector_name: string;
  first_report_photo_url: string | null;
}

export const usePendingIssues = () => {
  const [issues, setIssues] = useState<PendingIssue[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPendingIssues = async () => {
    try {
      setLoading(true);
      setError(null);

      const anonKey = import.meta.env.VITE_TASKBLOOM_SUPABASE_ANON_KEY || 
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14dGthYmVqZHNvcWtndHFqYWF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQwNTU4MjUsImV4cCI6MjAzOTYzMTgyNX0.QNLi5ZxZ8bNEe0gV6rGx3Nb99jkPR38ePdNI7y8dItA';

      const url = `${SUPABASE_URL}/functions/v1/${FUNCTION_NAME}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${anonKey}`,
          'apikey': anonKey,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setIssues(data);
    } catch (err: any) {
      console.error('Error fetching pending issues:', err);
      setError(err.message || 'Có lỗi khi tải danh sách vấn đề');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingIssues();
  }, []);

  return {
    issues,
    loading,
    error,
    refetch: fetchPendingIssues,
  };
};
